import {
  GET_NOTIFICATIONS,
  SET_NOTIFICATIONS_LOADING,
  SET_NOTIFICATIONS_TOTAL,
  SET_NOTIFICATIONS_UNREAD,
  SET_NOTIFICATION_STATUS,
  SET_ALL_NOTIFICATIONS_STATUS,
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
} from '../actions/Notifications';

const initialState = {
  notifications: [],
  total: null,
  unread: 0,
  loading: false,
};

export const Notifications = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications === null ? [] :
          state.notifications.concat(action.notifications),
      };

    case SET_NOTIFICATIONS_LOADING:
      return ({ ...state, loading: action.loading });

    case SET_NOTIFICATIONS_TOTAL:
      return ({ ...state, total: action.total });

    case SET_NOTIFICATIONS_UNREAD:
      return ({ ...state, unread: action.unread });

    case SET_NOTIFICATION_STATUS: {
      const notifications = [...state.notifications];
      const idx = notifications.findIndex(n => n.id === action.notificationId);
      if (idx >= 0) {
        notifications[idx].unread = action.unread;
      }
      return ({ ...state, notifications });
    }

    case SET_ALL_NOTIFICATIONS_STATUS: {
      const notifications = [...state.notifications];
      return ({
        ...state,
        notifications: notifications.map(n => ({ ...n, unread: action.unread })),
      });
    }

    case REMOVE_NOTIFICATION:
      return ({
        ...state,
        notifications: state.notifications.filter(n => (n.id !== action.notificationId)),
      });

    case ADD_NOTIFICATION:
      return ({
        ...state,
        notifications: [action.notification].concat(state.notifications),
        total: state.total + 1,
        unread: state.unread + 1,
      });

    default:
      return state;
  }
};
